// Device Selectors
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceState } from './device.state';

export const selectDeviceState = createFeatureSelector<DeviceState>('device');

// Basic selectors
export const selectDeviceId = createSelector(
  selectDeviceState,
  (state) => state.deviceId
);

export const selectIdentity = createSelector(
  selectDeviceState,
  (state) => state.identity
);

export const selectTwin = createSelector(
  selectDeviceState,
  (state) => state.twin
);

export const selectConnectionState = createSelector(
  selectDeviceState,
  (state) => state.connectionState
);

export const selectDeviceLoading = createSelector(
  selectDeviceState,
  (state) => state.loading
);

export const selectDeviceError = createSelector(
  selectDeviceState,
  (state) => state.error
);

// Derived selectors
export const selectIsConnected = createSelector(
  selectConnectionState,
  (connectionState) => connectionState === 'Connected'
);

export const selectIsDisconnected = createSelector(
  selectConnectionState,
  (connectionState) => connectionState === 'Disconnected'
);

export const selectHasIdentity = createSelector(
  selectIdentity,
  (identity) => !!identity
);

// Direct Method selectors
export const selectDirectMethodResult = createSelector(
  selectDeviceState,
  (state) => state.directMethodResult
);

export const selectDirectMethodLoading = createSelector(
  selectDeviceState,
  (state) => state.directMethodLoading
);

export const selectDirectMethodError = createSelector(
  selectDeviceState,
  (state) => state.directMethodError
);

// C2D selectors
export const selectC2DResult = createSelector(
  selectDeviceState,
  (state) => state.c2dResult
);

export const selectC2DSending = createSelector(
  selectDeviceState,
  (state) => state.c2dSending
);

export const selectC2DError = createSelector(
  selectDeviceState,
  (state) => state.c2dError
);

// Telemetry selectors
export const selectTelemetryMessages = createSelector(
  selectDeviceState,
  (state) => state.telemetryMessages
);

export const selectTelemetryLoading = createSelector(
  selectDeviceState,
  (state) => state.telemetryLoading
);

export const selectTelemetryError = createSelector(
  selectDeviceState,
  (state) => state.telemetryError
);

export const selectLatestTelemetry = createSelector(
  selectTelemetryMessages,
  (messages) => messages.length > 0 ? messages[0] : null
);

export const selectTelemetryCount = createSelector(
  selectTelemetryMessages,
  (messages) => messages.length
);
